export const resetState = (type) => dispatch => {
  dispatch({
    type,
  });
}